export default {
  log: {},
  GA: ['UA-5488627-3', 'UA-141211537-2'],
  idle: {
    name: 'idle',
    time: 6 * 600000,
    events: ['mousemove', 'keydown', 'mousedown', 'touchstart'],
  },
};
